import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Row, FormGroup, Input } from 'reactstrap';
import { AvForm, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import i18n from '../../../i18next';

import {
    MENU_ITEMS_TYPES_PLURALS,
    MENU_ITEM_TYPE_MENU,
    MENU_ITEM_TYPE_CATEGORY,
    MENU_ITEM_TYPE_PRODUCT,
    MENU_ITEM_TYPE_DEALS,
    ALL_MENU,
    INCLUDE,
    EXCLUDE
} from '../../../utils/Constants';
import { loadMenus, resetMenus, loadCategories, resetCategories, loadProducts, resetProducts, dispatchErrorMessage } from '../../../actions/index';
import { capitalizeFirstLetter } from '../../../utils/CommonUtils';
import BaseMenuItemScreen from '../posmenu/BaseMenuItemScreen';
import MenuItemsColumn from '../posmenu/MenuItemsColumn';

class PromotionCategoryProductScreen extends BaseMenuItemScreen {
    constructor(props) {
        super(props);

        this.state = this.getInitialBaseState();
        this.state['coverageType'] = ALL_MENU;
        this.state['menuDtos'] = [];
        this.state['categoryDtos'] = [];
        this.state['productDtos'] = [];
        this.state['stateAlreadyCopiedFromProps'] = false;
        this.state['excludeMealDeal'] = true;
        this.state['discountNonDiscountableProducts'] = null;

        this.changeRadioBtnsState = this.changeRadioBtnsState.bind(this);
        this.changeMasterCheckboxState = this.changeMasterCheckboxState.bind(this);
        this.renderTitleRow = this.renderTitleRow.bind(this);
        this.isTitleRowChecked = this.isTitleRowChecked.bind(this);
        this.renderItemsChekbox = this.renderItemsChekbox.bind(this);
        this.isChecked = this.isChecked.bind(this)
    }

    componentDidMount() {
        this.props.loadMenus(this.props.restaurantId);
    }

    componentWillUnmount() {
        // Send the updated state data to the parent component
        this.props.getPageData(this.state);
    }

    componentDidUpdate(prevProps) {
        const newDtos = [];
        const newCategoryDtos = this.state.categoryDtos.slice(0);
        const newProductDtos = this.state.productDtos.slice(0);
        let isItemAlreadyInState = false;

        if (this.props.categories !== prevProps.categories) {
            const categoryDtos = this.props.categories.slice(0);

            categoryDtos.map(categoryProp => {
                this.state.menuDtos.map(menuState => {
                    if (categoryProp.parentId === menuState.id) {
                        newDtos.push(categoryProp);
                    }
                });
            });
            //newDtos == currently loaded categories
            // then I compare them to the categories in state and if there are any matches SHOULD do nothing 
            // ELSE I push them all
            newDtos.map(newDto => {
                this.state.categoryDtos.map(categoryState => {
                    if (newDto.id === categoryState.id) {
                        isItemAlreadyInState = true;
                    }
                });
                if (!isItemAlreadyInState) {
                    newCategoryDtos.push(newDto);
                }
            });

            if (!isItemAlreadyInState) {
                this.setState({
                    ...this.state,
                    categoryDtos: newCategoryDtos
                });
            }
        } else if (this.props.products !== prevProps.products) {
            const productDtos = this.props.products.slice(0);

            productDtos.map(productProp => {
                this.state.categoryDtos.map(categoryState => {
                    if (productProp.parentId === categoryState.id) {
                        newDtos.push(productProp);
                    }
                });
            });

            newDtos.map(newDto => {
                this.state.productDtos.map(productState => {
                    if (newDto.id === productState.id) {
                        isItemAlreadyInState = true;
                    }
                });

                if (!isItemAlreadyInState) {
                    newProductDtos.push(newDto);
                }
            });

            if (!isItemAlreadyInState) {
                this.setState({
                    ...this.state,
                    productDtos: newProductDtos
                });
            }
        }
    }

    submitForm() {
        // if valid calls onGoToNextPage if not dont call it
        let validFormData = this.handleTabValidation();

        if (validFormData) {
            this.props.goToNextPage();
            this.resetLocalState();
        }
    }

    resetLocalState() {
        this.setState({
            menuDtos: [],
            categoryDtos: [],
            productDtos: []
        });
    }

    handleTabValidation() {
        let validFormData = true;

        if (this.state.coverageType !== ALL_MENU && this.state.menuDtos.length === 0) {
            this.props.cancelTabChangeRequest();
            validFormData = false;
            this.props.dispatchErrorMessage(i18n.t('screens:promotionCategoryProductScreen.validationMsg'));
        }

        return validFormData;
    }

    copyStateFromProps() {
        if (this.props.selectedPromotion !== undefined && this.props.selectedPromotion !== null
            && this.props.selectedPromotion.menuDtos !== undefined && this.props.selectedPromotion.categoryDtos
            && this.props.selectedPromotion.productDtos !== undefined && !this.state.copyStateFromProps) {

            this.setState({
                coverageType: this.props.selectedPromotion.coverageType,
                menuDtos: this.props.selectedPromotion.menuDtos,
                categoryDtos: this.props.selectedPromotion.categoryDtos,
                productDtos: this.props.selectedPromotion.productDtos,
                discountNonDiscountableProducts: this.props.selectedPromotion.discountNonDiscountableProducts,
                copyStateFromProps: true
            });
        }
    }

    changeRadioBtnsState(event) {
        event.persist();
        this.setState({
            coverageType: event.target.value
        });
    }

    changeMasterCheckboxState(column) {
        const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
        let newDtos = [];
        let newDtosArray = this.state[`${column}Dtos`].slice(0);

        this.props[itemsTypePlural].map(propsItem => {
            let isItemFoundInState = false;

            this.state[`${column}Dtos`].map(stateItem => {

                if (propsItem.id === stateItem.id) {
                    isItemFoundInState = true;
                }
            });

            if (!isItemFoundInState) {
                newDtos.push(propsItem);
            }
        });

        if (newDtos.length !== 0) { // add items
            newDtos.map(newDto => {
                newDtosArray.push(newDto);
            });
        } else { // remove items
            this.state[`${column}Dtos`].map(stateItem => {
                this.props[itemsTypePlural].map(propsItem => {
                    if (stateItem.id === propsItem.id) {
                        const indexOfItem = newDtosArray.indexOf(stateItem);
                        newDtosArray.splice(indexOfItem, 1);
                    }
                });
            });
        }

        if (column === 'category' && newDtosArray.length === 0) {
            this.setState({
                ...this.state,
                [`${column}Dtos`]: newDtosArray,
                productDtos: []
            });
            /** TODO logic here needs improvements and handling of additional cases */
        // } else if (column === 'product' && !newDtosArray.length) {
        //     let newCategoryDtos = this.state.categoryDtos.filter(category => this.state.activeCategory.id !== category.id);
        //     console.log('ELSE IF newCategoryDtos ', newCategoryDtos)
        //     return this.setState({
        //         ...this.state,
        //         [`${column}Dtos`]: newDtosArray,
        //         categoryDtos: newCategoryDtos
        //     });
        } else {
            this.setState({
                ...this.state,
                [`${column}Dtos`]: newDtosArray
            });
        }
    }

    changeChildrenCheckboxes(item, column, checkOnly) {     // checkOnly does check element item onSelect but does not uncheck it if already selected
        const newDtos = this.state[`${column}Dtos`].slice(0);
        const newCategoryDtos = [];
        const newProductDtos = [];
        let isItemFoundInState = false;

        if (newDtos.length > 0) {
            newDtos.map(dto => {
                if (dto.id === item.id) { // if item is found in state we remove it
                    isItemFoundInState = true;
                    if (!checkOnly) {
                        this.removeItemFromState(newDtos, dto, column, newCategoryDtos, newProductDtos);
                    }
                }
            });
            if (!isItemFoundInState) { // if item is not found in state we add it
                this.addItemToState(newDtos, item, column, !this.state.discountNonDiscountableProducts);
            }
        } else {
            this.addItemToState(newDtos, item, column, !this.state.discountNonDiscountableProducts); // if state Dtos are empty we add items;
        }

        if (column === MENU_ITEM_TYPE_MENU && isItemFoundInState && !checkOnly) {
            this.setState({
                [`${column}Dtos`]: newDtos,
                categoryDtos: newCategoryDtos,
                productDtos: newProductDtos
            });
        } else if (column === MENU_ITEM_TYPE_CATEGORY && isItemFoundInState && !checkOnly) {
            this.setState({
                [`${column}Dtos`]: newDtos,
                productDtos: newProductDtos
            });
            /** TODO logic here needs improvements and handling of additional cases */
        } else {// Product DTOs will be here
            // TODO find the product with no category
            // try to add this category from props maybe
            // let activeCategoryNotInState = this.state.categoryDtos.filter(categoryDto => this.state.activeCategory.id === categoryDto.id);
            // let newlyAddedCategories = this.state.categoryDtos.slice();
            // for (let i = 0; i < newDtos.length; i++) {
            //     let product = newDtos[i];
            //     if (product.parentId === this.state.activeCategory.id && !activeCategoryNotInState.length) {
            //         console.log('HERE ')
            //         newlyAddedCategories.push(this.state.activeCategory);
            //         break;
            //     }
            // }

            this.setState({
                [`${column}Dtos`]: newDtos,
                // categoryDtos: newlyAddedCategories.length > this.state.categoryDtos.length ? newlyAddedCategories : this.state.categoryDtos 
            });
        }
    }

    addItemToState(newDtos, item, column, excludeMealDeal) {
        newDtos.push(item);
        this.loadColumnsData(item, false, column, true, this.props.restaurantId, excludeMealDeal);
    }

    removeItemFromState(newDtos, dto, column, newCategoryDtos, newProductDtos) {
        newDtos.splice(newDtos.indexOf(dto), 1);

        if (column === MENU_ITEM_TYPE_MENU) {
            this.clearRelatedCategoriesState(newCategoryDtos);
        }
        if (column === MENU_ITEM_TYPE_MENU || column === MENU_ITEM_TYPE_CATEGORY) {
            this.clearRelatedProductsState(newProductDtos, newCategoryDtos);
        }
    }

    clearRelatedCategoriesState(newCategoryDtos) {
        this.state.categoryDtos.map(stateItem => {
            let categoryFoundInProps = false;

            this.props.categories.map(propsItem => {
                if (propsItem.id === stateItem.id) {
                    categoryFoundInProps = true;
                }
            });

            if (!categoryFoundInProps) {
                newCategoryDtos.push(stateItem);
            }
        });

        this.props.resetCategories();
    }

    clearRelatedProductsState(newProductDtos, newCategoryDtos) {
        this.state.productDtos.map(stateItem => {
            let productFoundInProps = false, productCategoryFoundInState = false;

            this.props.products.map(propsItem => {
                if (propsItem.id === stateItem.id) {
                    productFoundInProps = true;
                }
            });
            // check if there are products from a removed category or categories
            newCategoryDtos.map(newCategoryDto => {
                if (newCategoryDto.id === stateItem.parentId) {
                    productCategoryFoundInState = true;
                }
            });

            if (!productFoundInProps && productCategoryFoundInState) {
                newProductDtos.push(stateItem);
            }
        });

        this.props.resetProducts();
    }

    renderRadioGroup() {
        const { radioBtnGroup } = styles;

        return (
            <AvRadioGroup inline
                name="coverageType" className="promotionCategoryProduct" style={radioBtnGroup}
                value={this.state.coverageType} onChange={this.changeRadioBtnsState}
            >
                <AvRadio label={i18n.t('screens:promotionCategoryProductScreen.radioFull')} value={ALL_MENU} />
                <AvRadio label={i18n.t('screens:promotionCategoryProductScreen.radioInclude')} value={INCLUDE} />
                <AvRadio label={i18n.t('screens:promotionCategoryProductScreen.radioExclude')} value={EXCLUDE} />
            </AvRadioGroup>
        );
    }

    renderInfoMsg() {
        const { infoMessage } = styles;

        return (
            <span style={infoMessage}>{i18n.t('screens:promotionCategoryProductScreen.infoMsg')}</span>
        );
    }

    renderTitleRow(column) {
        const { masterCheckbox } = styles;

        return (
            <FormGroup check>
                <Input className='masterCheckboxes'
                    type="checkbox" name={`${column}AllCheckbox`} style={masterCheckbox}
                    onChange={() => this.changeMasterCheckboxState(column)}
                    checked={this.isTitleRowChecked(column)}
                />
            </FormGroup>
        );
    }

    isTitleRowChecked(column) {
        const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
        let itemsFoundInStateCount = 0;

        this.props[itemsTypePlural].map(propsItem => {

            this.state[`${column}Dtos`].map(stateItem => {

                if (propsItem.id === stateItem.id) {
                    itemsFoundInStateCount++;
                }
            });
        });

        if (this.props[itemsTypePlural].length === itemsFoundInStateCount && this.props[itemsTypePlural].length !== 0) {
            return true;
        } else {
            return false;
        }
    }

    renderItemsChekbox(item, column) {
        const { itemsChekbox, itemsCheckboxInactive } = styles;
        const isActive = this.state[`active${capitalizeFirstLetter(column)}`].id === item.id;
        const changeStyleIfActive = isActive ? itemsChekbox : itemsCheckboxInactive;

        return (
            <FormGroup check>
                <Input className='childrenCheckboxes' disabled={!isActive}
                    type="checkbox" name={`${item.id}`} style={changeStyleIfActive}
                    onChange={() => this.changeChildrenCheckboxes(item, column, false)}
                    checked={this.isChecked(item, column)}
                />
            </FormGroup>
        );
    }

    isChecked(item, column) {
        let isTrueOrFalse = false;

        this.state[`${column}Dtos`].map(singleDto => {
            if (singleDto.id === item.id) {
                isTrueOrFalse = true;
            }
        });

        return isTrueOrFalse;
    }

    renderTitleParagraph(column) {
        const { titleStyle } = styles;
        const columnNameChange = (this.state.activeCategory.posId === "-123" && column === MENU_ITEM_TYPE_PRODUCT) ? MENU_ITEM_TYPE_DEALS : column;

        return (
            <p style={titleStyle}>{i18n.t(`screens:menuConfigScreen.${columnNameChange}`)}</p>
        );
    }

    renderMenuColumns() {
        const { noMargins } = styles;
        const menuConfigColumns = [MENU_ITEM_TYPE_MENU, MENU_ITEM_TYPE_CATEGORY, MENU_ITEM_TYPE_PRODUCT];
        const isRowHidden = this.state.coverageType === ALL_MENU ? true : false;
        const doNotCallQuestions = true;
        const restaurantId = this.props.restaurantId

        return (
            <Row style={noMargins} hidden={isRowHidden}>
                {menuConfigColumns.map((column, i) => {
                    const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];

                    const hideMasterCheckboxes = column === MENU_ITEM_TYPE_CATEGORY ? (this.state.activeMenu.name !== undefined ? false : true)
                        : (column === MENU_ITEM_TYPE_PRODUCT ? (this.state.activeCategory.name !== undefined ? false : true) : false);

                    return (
                        <MenuItemsColumn
                            key={i}
                            name={`${column}-menuItemsColumn`}
                            hiddenRow={hideMasterCheckboxes}
                            items={this.props[itemsTypePlural]}
                            activeItem={this.state[`active${capitalizeFirstLetter(column)}`]}
                            onSelect={(item) => { this.loadColumnsData(item, false, column, doNotCallQuestions, restaurantId, !this.state.discountNonDiscountableProducts), this.changeChildrenCheckboxes(item, column, true) }}
                            renderTitleRow={this.renderTitleRow(column)}
                            renderTitleParagraph={this.renderTitleParagraph(column)}
                            renderActionComponent={this.renderItemsChekbox}
                            sortDisabled={true}
                            column={column}
                            styles={styles}
                        />
                    );
                })}
            </Row>
        );
    }

    render() {
        const { formContainer } = styles;

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        this.copyStateFromProps();

        return (
            <AvForm style={formContainer}>
                {this.renderRadioGroup()}
                {this.renderInfoMsg()}
                {this.renderMenuColumns()}
            </AvForm>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menus: state.menus,
        categories: state.categories,
        products: state.products
    }
}

export default connect(mapStateToProps, { loadMenus, resetMenus, loadCategories, resetCategories, loadProducts, resetProducts, dispatchErrorMessage })(PromotionCategoryProductScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    infoMessage: {
        fontSize: 12,
        color: '#b7b7b7',
    },
    radioBtnGroup: {
        fontSize: 16,
        height: 24,
        marginBottom: 0,
        backgroundColor: '#F7F7F7'
    },
    noMargins: {
        marginLeft: 0,
        marginRight: 0
    },
    rowMarginRight: {
        marginRight: 0,
        marginLeft: 0
    },
    masterCheckbox: {
        cursor: 'pointer',
        top: 2
    },
    itemsChekbox: {
        cursor: 'pointer',
        top: 2,
        // bottom: 20,
        padding: 0,
        marginTop: '5px'
    },
    itemsCheckboxInactive: {
        top: 2,
        // bottom: 20,
        padding: 0,
        marginTop: '5px'
    },
    // MENU CONFIG ITEM STYLES
    flexCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    rowStyle: {
        width: '100%',
        height: 182,
        backgroundColor: '#F0F0F0',
        borderTop: '1px solid grey',
        marginRight: 5,
        marginLeft: 0,
        overflowY: 'overlay'
    },
    titleColumn: {
        width: '20%',
        float: 'left',
        padding: '5px 5px 0 0',
    },
    titleStyle: {
        marginBottom: 0,
        display: 'flex',

    },
    iconsColumn: {
        paddingRight: 0
    },
    listGroupItem: {
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        padding: '5px 5px 5px 5px'
    },
    fullWidthStyle: {
        width: '100%'
    },
    activeStyle: {
        backgroundColor: 'white',
        color: "#0288D1",
        padding: '5px 5px 5px 5px'
    },
    selectedItem: {
        color: "#0288D1",
        cursor: 'pointer'
    },
    activeIconStyle: {
        color: "#0288D1"
    },
    inactiveStyle: {
        color: "#cccccf",
        cursor: 'pointer'
    },
    inactiveStyleItalics: {
        fontStyle: "italic",
        color: "#cccccf",
        cursor: 'pointer'
    },
    selectedItemItalics: {
        fontStyle: "italic",
        color: "#0288D1",
        cursor: 'pointer'
    },
    activeNotPublished: {
        fontStyle: "italic",
        cursor: 'pointer'
    },
    buttonFloatRight: {
        float: 'right'
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionCategoryProductScreen.js